// 脚本相关atoms
export * from './scriptAtoms';
// 会话相关atoms  
export * from './sessionAtoms';
// UI状态相关atoms
export * from './uiAtoms';
// 设置相关atoms
export * from './settingsAtoms';
// 重新导出jotai核心功能
export { atom, useAtom, useAtomValue, useSetAtom } from 'jotai';
export { atomWithStorage, selectAtom, splitAtom } from 'jotai/utils';
// 常用的组合atoms和工具函数
import { atom } from 'jotai';
import { currentSessionAtom } from './sessionAtoms';
import { sidebarOpenAtom, sidebarActiveTabAtom } from './uiAtoms';
// 应用整体状态（用于调试和开发工具）
export const appStateAtom = atom((get) => ({
    currentSession: get(currentSessionAtom),
    sidebar: {
        isOpen: get(sidebarOpenAtom),
        activeTab: get(sidebarActiveTabAtom),
    },
    // 可以根据需要添加更多状态
}));
// 应用准备就绪状态
export const appReadyAtom = atom((get) => {
    // 检查应用是否准备就绪的逻辑
    // 比如检查必要的数据是否已加载
    return true; // 暂时总是返回true
});
